export default {
  "common": {
    "all": "All",
    "cancel": "Cancel",
    "userAgreement": "User Agreement",
    "close": "Close",
    "submit": "Submit",
    "submitting": "Submitting...",
    "report": "Report",
    "loading": "Loading...",
    "noMore": "No more",
    "search": "Search",
    "today": "Today",
    "collapse": "Collapse",
    "retryLater": "Try again later",
    "tips": "Tips",
    "friendlyReminder": "Reminder",
    "finish": "Finish",
    "noData": "No relevant data",
    "retry": "Retry",
    "reset": "Reset",
    "confirm": "Confirm",
    "continue": "Continue",
    "notAvailableYet": "Unavailable"
  },
  "tab": {
    "home": "Home",
    "card": "Cards",
    "mine": "My"
  },
  "auth": {
    "loginTitle": "Web3 Pay Wallet",
    "loginSubtitle": "A single card connects assets and consumption, effortlessly unlocking a global payment experience",
    "createWallet": "Create Wallet",
    "importWallet": "My wallet",
    "choiceOneWay": "Choose a method to quickly start your secure digital asset journey",
    "iHaveWallet": "My wallet",
    "choiceOneWay2": "Choose a login method to quickly start your secure digital asset journey",
    "createUseEmail": "Create with Email",
    "createUseRemWord": "Create a recovery phrase wallet",
    "loginUseEmail": "Log in with Email",
    "loginByReWord": "Import with Private Key / Recovery Phrase",
    "validByEmail": "Quick email verification, simple and convenient",
    "validByReWord": "Fully controlled by your recovery phrase, secure and decentralized",
    "validByReWord2": "Import with recovery phrase/private key/wallet address",
    "emailLoginRegister": "Email Login/Register",
    "inviteRegisterTitleStart": "Tap to pay,",
    "inviteRegisterTitleEnd": "made easy",
    "inviteRegisterStartRewards": "Start earning",
    "inviteRegisterWelcome": "Welcome to WinPay!",
    "agreePrefix": "By continuing to use, you agree to the WinPay Wallet's ",
    "privacyPolicy": "Privacy Policy",
    "and": "and",
    "userAgreement": "User Agreement",
    "agreementMessage": "Please read the Privacy Policy and User Agreement first. Clicking 'Continue' indicates that you agree to the WinPay Wallet's Privacy Policy and User Agreement.",
    "agreementConfirm": "I have read and agree",
    "addEmailAddress": "Add email address",
    "inputEmailAddress": "Enter email address",
    "emailAccountTip": "This email will be your login account.",
    "emailAddress": "Email",
    "email": "Email",
    "emailLogin": "Email Login",
    "enterEmail": "Enter your email",
    "enterEmailAddress": "Enter email address",
    "register": "Register",
    "login": "Login",
    "enterVerificationCode": "Enter code",
    "codeSentTo": "Code sent to ",
    "codeSentToEmail": "The verification code was sent to your email:",
    "codeValid": ", valid for 10 min.",
    "emailCode": "Email verification code",
    "enterEmailCode": "Enter email code",
    "getCode": "Get code",
    "resend": "Resend",
    "codeSent": "Code sent",
    "codeSentValid": "*Code sent. Valid for 10 min",
    "cannotReceiveCode": "Can't receive the code?",
    "checkSpamFolder": "Check your spam folder",
    "codeHelpTitle": "Can't receive the verification code?",
    "codeHelpIntro": "Verification codes are usually delivered within 1 minute. If you haven't received yours yet:",
    "codeHelpEmailTitle": "Check that your email address is correct",
    "codeHelpEmailDesc": "Make sure the code was sent to the email address you expected. A small spelling mistake is the most common reason it isn't delivered.",
    "codeHelpSpamTitle": "Check your spam folder",
    "codeHelpSpamDesc": "Verification emails may sometimes be marked as spam. Please mark them as not spam to help future codes reach your inbox.",
    "codeHelpResendTitle": "Request a new verification code",
    "codeHelpResendDesc": "Be sure to use the latest verification code because older codes expire.",
    "verify": "Verify",
    "inputPassword": "Enter Password",
    "setWalletPassword": "Set Wallet Password",
    "walletPasswordTip": "Set a password to manage your wallet. This password cannot be recovered. If you forget your password, you can go to my homepage - Security Settings - Retrieve Password, or log in again with your email and reset your payment password!",
    "setPasswordForTransaction": "Set wallet password for verification.",
    "strongPassword": "Enter a strong password",
    "enterPasswordPlaceholder": "Please enter password",
    "enterPassword": "Enter",
    "confirmPassword": "Re-enter the password",
    "passwordTooShort": "*Password is too short. At least 8 characters.",
    "passwordWeak": "Weak password",
    "passwordMedium": "Moderate password",
    "passwordStrong": "Strong password",
    "passwordMismatch": "Passwords do not match",
    "passwordError": "Incorrect Password",
    "bindEmail": "Bind Email",
    "bindEmailIntro": "For your financial security, please bind an email",
    "emailForRecovery": "For password recovery",
    "emailRequired": "Email cannot be empty",
    "codeRequired": "Code cannot be empty",
    "invitationCode": "Invite code",
    "enterInvitationCode": "Please enter the invitation code (optional)",
    "verificationFailed": "Verification failed",
    "walletReady": "Wallet ready",
    "walletCreatedSuccess": "Welcome Back!",
    "walletExploreTip": "WinPay full functionality enabled",
    "firstExploreCreateTitle": "Wallet created successfully!",
    "firstExploreRegisterTitle": "Login successful!",
    "firstExploreLoginTitle": "Welcome back!",
    "firstExploreImportTitle": "Wallet imported successfully!",
    "firstExploreCreateSubtitle": "You can now explore the public-chain crypto wallet",
    "firstExploreDefaultSubtitle": "WinPay full functionality enabled",
    "startExplore": "Start exploring",
    "importTitle": "Enter mnemonic phrase or private key",
    "importWalletTip": "Separate mnemonic words with spaces. Supports importing from any wallet.",
    "importPlaceholder": "Enter mnemonic phrase or private key",
    "importInvalid": "Invalid input",
    "importTip1": "WinPay Wallet does not store your mnemonic or private key. You control your assets.",
    "importTip2": "Make sure no one else or camera can see your secret.",
    "importTip3": "It is recommended to manually input or scan to import your mnemonic phrase or private key.",
    "continue": "Continue",
    "backupWarnTitle": "Please Keep in Mind Before Backup!",
    "backupTipWrite": "Handwriting is Recommended",
    "backupTipNoCopy": "Do Not Copy and Save",
    "backupTipNoScreenshot": "Do Not Take Screenshots",
    "backupWarn1Title": "Mnemonic is Equivalent to Your Wallet Password",
    "backupWarn1Desc": "Anyone with your mnemonic controls your assets. Leaks are irreversible.",
    "backupWarn2Title": "Please Handwrite or Store in Cold Wallet or Other Offline Devices",
    "backupWarn2Desc": "If Copied or Saved as Screenshot, the Mnemonic May Be Leaked",
    "backupWarn3Title": "Keep Your Mnemonic in a Safe Place",
    "backupWarn3Desc": "Once Lost, Assets Cannot Be Recovered",
    "backupWarnCheck": "You are responsible for your mnemonic. Back it up — loss means permanent asset loss.",
    "backupMnemonic": "Backup Mnemonic",
    "mnemonicDesc": "The recovery phrase is your wallet password. Keep it safe.",
    "verifyMnemonicTitle": "Verify Mnemonic",
    "verifyMnemonicTip": "Please Verify the Mnemonic in Order",
    "ordinalNumber": "Word {number}",
    "mnemonicCheckFailed": "Recovery phrase verification failed",
    "mnemonicCheckSuccess": "Recovery phrase verified successfully",
    "mnemonicUnavailable": "No mnemonic backup available for this wallet",
    "verifyWalletPassword": "Enter payment password",
    "forgotPasswordRecovery": "Forgot password? Reset it",
    "resetPaymentPassword": "Recover password",
    "resetPaymentPasswordTip": "Verify your bound email first, then reset the payment password",
    "changePassword": "Change Password",
    "currentPassword": "Current Password",
    "enterCurrentPassword": "Enter Current Password",
    "setPassword": "Set Password",
    "pleaseSetNewPasswordMin8": "Set a new password, at least 8 chars",
    "newPassword": "New password",
    "setNewPasswordMin8": "Set a new password with at least 8 characters",
    "enterNewPassword": "Enter new password",
    "confirmNewPassword": "Confirm New Password",
    "setNewPasswordAgain": "Confirm the new password",
    "currentPasswordIncorrect": "Current password is incorrect",
    "newPasswordSameAsOld": "New password cannot match old password",
    "passwordsNotMatch": "The new passwords do not match",
    "passwordOnlySavedLocally1": "I understand that the password is only saved locally on this device,",
    "passwordOnlySavedLocally2": "and cannot be recovered if forgotten",
    "noBoundEmailRecover": "You have not bound an email, cannot recover password",
    "goBindEmail": "Go bind email",
    "boundEmail": "Verify email",
    "changeSuccess": "Change successfully",
    "bindEmailTip": "Please bind your email before recovering your password",
    "bindEmailTip2": "Bind your email before password recovery to receive verification messages.",
    "bindEmailTip3": "Please bind your email first",
    "noBindEmail": "No",
    "canUseWallet": "Great! You can use the wallet now.",
    "successfullyProtected": "You have successfully protected your wallet. Remember to keep your mnemonic safe, as it cannot be recovered if lost! You can always back up your mnemonic by going to Settings -> Wallet Management -> Select Wallet -> Export Mnemonic",
    "startUseApp": "Start using WinPay Wallet",
    "next": "Next"
  },
  "home": {
    "title": "Home",
    "totalAssets": "Total assets",
    "receive": "Receive",
    "scan": "Scan",
    "transfer": "Transfer",
    "topup": "Recharge",
    "withdraw": "Withdraw",
    "bill": "Transaction",
    "invite": "Invite",
    "invitCode": "Invite code QR Code",
    "more": "More",
    "recent": "Shortcuts",
    "community": "Community",
    "token": "Token",
    "turnover": "Transactions",
    "nft": "NFT",
    "accountAssets": "Account",
    "cardAssets": "Cards",
    "cardWallet": "Cards",
    "backup": "Go Backup",
    "winpayCardPayment": "WinPay Virtual Card + Physical Card Dual Payment Support",
    "applyExclusiveCard": "Apply card",
    "nodeFast": "Node OK",
    "nodeSlow": "Node Slow",
    "nodeBad": "Node Error",
    "node": "Node",
    "viewAccount": "Select Account",
    "selectAccount": "Select Account",
    "selectNode": "Select Node",
    "blockHeightExplain": "Lower latency and newer block height usually mean a better node connection.",
    "recommendNode": "Recommended Node",
    "blockHeight": "Block Height",
    "currentAccountNotSupport": "The current account does not support this network.",
    "noData": "No data available",
    "actionTodo": "Unavailable",
    "cardTailNo": "Card",
    "tradeSuccess": "Trans Successful",
    "tradeFailed": "Trans Failed",
    "kycRetryRequired": "KYC failed. Verify again.",
    "viewNow": "View now"
  },
  "wallet": {
    "chooseCoin": "Select Another Currency",
    "chooseNetwork": "Select Network",
    "copyAddress": "Copy Address",
    "copySuccess": "Copy Success",
    "copyFailed": "Copy Failed",
    "saveSuccess": "Saved Successfully",
    "saveFailed": "Save failed",
    "depositAddress": "Deposit Address",
    "topupNotes": "Important Notes:",
    "topupNote1Prefix": "1. The recharge amount is based on",
    "topupNote1Highlight1": "\"Actual Arrival\"",
    "topupNote1Middle": ", depending on the platform",
    "topupNote1Highlight2": "\"Actual Arrival\"",
    "topupNote1Suffix": " may differ across platforms because outgoing platform fees are deducted before arrival.",
    "topupNote2": "2. Do not deposit any non-USDT assets to the address above, or the assets may not be recoverable.",
    "topupNote3": "3. After depositing to the address above, network confirmation is required. Funds arrive after 60 confirmations and can be withdrawn after 910 confirmations.",
    "withdrawAddress": "Withdraw Address",
    "enterWithdrawAddress": "Enter the withdrawal address",
    "withdrawAmount": "Withdraw Amount",
    "withdrawAmountLabel": "Amount",
    "maxAmountLabel": "Maximum Amount",
    "available": "Available",
    "enterAmount": "Enter the amount",
    "enterWithdrawAmount": "Enter the withdrawal amount",
    "all": "All",
    "fee": "Fee",
    "received": "Expected Arrival",
    "submitWithdraw": "Submit Withdrawal Request",
    "withdrawNotes": "Important Notes:",
    "withdrawNote1Prefix": "1. Minimum withdrawal amount is ",
    "withdrawNote2": "2. Please ensure the withdrawal address is accurate, otherwise assets cannot be recovered.",
    "withdrawNote3Prefix": "3. After approval",
    "withdrawNote3Suffix": "Hours to arrive, delays may occur due to network reasons",
    "withdrawNote4": "4. If it does not arrive for a long time, please contact customer service for checking",
    "withdrawUnavailable": "Withdrawals are currently closed",
    "withdrawConfirm": "Confirm withdrawal?",
    "withdrawSuccess": "Withdrawal request submitted successfully, please wait for admin approval",
    "billTitle": "Transaction",
    "billDetailTitle": "Details",
    "noBill": "No records",
    "noBillDetail": "No relevant data",
    "assetType": "Type",
    "recordType": "Record Type",
    "billTimeLabel": "Time",
    "choosePricingFiat": "Choose Pricing Currency",
    "hotFeatures": "Hot Features",
    "moreFeatures": "More Features",
    "walletFeatures": "Hot Features",
    "cardFeatures": "Card Features",
    "otherFeatures": "Other Features",
    "payment": "Receive",
    "scanCode": "Scan",
    "walletBackup": "Wallet Backup",
    "openCard": "Open Card Now",
    "GoOpenCard": "Go open the card",
    "physicalCard": "Physical card",
    "physicalUnavailable": "Physical card unavailable",
    "activateCard": "Activate physical card",
    "physicalTransfer": "Physical Transfer",
    "fundTransfer": "Transfer",
    "fundTransferUnavailable": "Feature unavailable",
    "receiveAddress": "Receive Address",
    "saveCollectionCode": "Save Collection Code",
    "transferInProperty": "Only transfer assets through {network}",
    "receiveTips": "Receive Tips",
    "receiveTip1": "Confirm the asset and current network before receiving.",
    "receiveTip2": "Wrong network or coin transfers may not be recoverable.",
    "openCamera": "Open Camera",
    "closeCamera": "Close Camera",
    "pasteScanResult": "Paste or enter scan result",
    "scanResult": "Scan Result",
    "cameraUnavailable": "Camera is unavailable in this browser",
    "cameraPermissionDenied": "Camera access is blocked. Please allow camera permission first.",
    "cameraPermissionHint": "If no permission prompt appears, check whether camera access is allowed in site permissions.",
    "cameraNotFound": "No camera device was found.",
    "cameraInUse": "Camera is currently being used by another app. Please close it and try again.",
    "cameraConstraintFailed": "The requested camera mode is not supported on this device, and fallback also failed.",
    "cameraSecureContextRequired": "This page is not running in a camera-safe browser context.",
    "cameraSecureContextHint": "On Android browsers, webpage camera access usually requires HTTPS or localhost. Using a LAN http address often will not trigger camera permission directly.",
    "cameraGuideTitle": "Unable to open camera",
    "iosCameraGuideTitle": "iPhone camera guide",
    "androidCameraGuideTitle": "Android camera guide",
    "cameraPermissionGuide": "1. In iPhone Safari, tap the \"aA\" button or the page menu near the address bar.<br/>2. Open Website Settings and change Camera to Allow.<br/>3. Return to this page, refresh it, and tap scan again.<br/>4. If you previously tapped \"Don’t Allow\", also check camera access in iPhone Settings for Safari.",
    "cameraSecureGuide": "This page must be opened in a secure context to access the camera.<br/>1. Make sure you are using the official domain or a secure link.<br/>2. Refresh the page and try again.<br/>3. If it still fails, reopen it in the system browser.",
    "cameraUnavailableGuide": "1. First make sure the iPhone camera works normally in the system Camera app.<br/>2. Check whether camera access is allowed for this website in Safari.<br/>3. Close any other app that may be using the camera, then try again.<br/>4. If it still fails, refresh the page or re-enter and retry.",
    "iosCameraPermissionGuide": "1. In iPhone Safari, tap the \"aA\" button or the page menu near the address bar.<br/>2. Open Website Settings and change Camera to Allow.<br/>3. Return to this page, refresh it, and tap scan again.<br/>4. If you previously tapped \"Don’t Allow\", also check camera access in iPhone Settings for Safari.",
    "iosCameraSecureGuide": "This page must be opened in a secure context to access the camera.<br/>1. Make sure you are using the official domain or a secure link.<br/>2. Refresh the page and try again.<br/>3. If it still fails, reopen it in the system browser.",
    "iosCameraUnavailableGuide": "1. First make sure the iPhone camera works normally in the system Camera app.<br/>2. Check whether camera access is allowed for this website in Safari.<br/>3. Close any other app that may be using the camera, then try again.<br/>4. If it still fails, refresh the page or re-enter and retry.",
    "androidCameraPermissionGuide": "1. Open Site Settings or Permissions in your Android browser for this website.<br/>2. Change Camera permission to Allow.<br/>3. If the system camera permission was denied before, open Android Settings - Apps - Browser - Permissions and allow Camera.<br/>4. Return to the page, refresh it, and tap scan again.",
    "androidCameraSecureGuide": "Most Android browsers require a secure context for camera access.<br/>1. Make sure the page is opened from the official domain or an HTTPS link.<br/>2. If you are using a LAN address, many Android browsers will not trigger camera permission.<br/>3. Switch to the official address, refresh the page, and try again.",
    "androidCameraUnavailableGuide": "1. First make sure the system Camera app works normally on your phone.<br/>2. Check that both the browser and Android system allow camera permission.<br/>3. Close other apps that may be using the camera and try again.<br/>4. If it still fails, refresh the page or try the system browser.",
    "androidScanGuideTitle": "Android scan guide",
    "androidScanGuide": "The camera is open, but this Android browser does not support the live scanning capability used on this page.<br/>1. Try the system browser or the latest Chrome first.<br/>2. Make sure camera permission is allowed for this website.<br/>3. Refresh the page and try again. If it still fails, switch to a browser that supports live web scanning.",
    "safariScanGuideTitle": "Safari scan guide",
    "safariScanGuide": "The camera is open, but iPhone Safari does not support the live scanning capability used on this page.<br/>1. First confirm camera permission is allowed for this website.<br/>2. Refresh the page and try once more.<br/>3. If it still cannot scan, please use a browser that supports live web scanning or complete scanning from another entry.",
    "scanNotSupportedGuide": "This browser does not support the live scanning capability used on this page.<br/>1. Make sure camera permission is already allowed for this website.<br/>2. Refresh the page and try once more.<br/>3. If it still fails, please switch to the system browser or another browser that supports live web scanning.",
    "scanNotSupported": "This browser does not support live QR scanning. Please try again in your system browser.",
    "scanSuccess": "Scanned",
    "transferRecord": "Transfer Records",
    "directTransfer": "Direct Transfer",
    "addressBookTransfer": "Address book",
    "scanTransfer": "Scan Transfer",
    "enterOrPasteAddress": "Enter or paste address",
    "transferAmount": "Transfer Amount",
    "transferHistory": "Transfer History",
    "noTransferRecord": "No transfer records",
    "transferConfirm": "Confirm transfer?",
    "addToken": "Add Token",
    "addNft": "Add NFT",
    "nftDetail": "NFT Details",
    "nftAssets": "Balance",
    "nftAssetView": "NFT",
    "nftSendTitle": "Send NFT",
    "nftSendAsset": "Asset",
    "sendNft": "Send",
    "removeNft": "Delete",
    "invalidAddress": "Enter a valid address",
    "nftTransferUnsupported": "NFT transfer is not supported on the current network",
    "nftSendSuccess": "Sent Successfully",
    "hotToken": "Hot Tokens",
    "hotNft": "Hot NFT",
    "customToken": "Custom Token",
    "customNft": "Custom NFT",
    "enterContractAddressSearch": "Enter contract address to search",
    "tokenAddress": "Token Address",
    "nftAddress": "NFT Address",
    "enterTokenAddress": "Enter the token address",
    "enterNftAddress": "Enter NFT contract address",
    "tokenSymbol": "Token Symbol",
    "enterTokenSymbol": "Enter the token symbol",
    "decimalPlaces": "Decimal Places",
    "tokenAdded": "Token Added",
    "addSuccess": "Add Success",
    "tokenDetail": "Token Detail",
    "propertyBalance": "Asset Balance",
    "transferIn": "Transfer In",
    "transferOut": "Transfer Out",
    "transferInAddress": "From address",
    "transferOutAddress": "To address",
    "transactionId": "Transaction ID",
    "blockchainBrowser": "Blockchain",
    "network": "Network",
    "pending": "Processing",
    "inTransaction": "In Transaction",
    "finish": "Finish",
    "signTodo": "Signing flow migration in progress",
    "exportMnemonic": "Export phrase",
    "exportPrivateKey": "Export Private Key",
    "sensitiveExportLabel": "Verify identity",
    "securityReminder": "Safety Reminder",
    "backupTip1": "Mnemonic and private key control your assets. Keep them offline.",
    "backupTip2": "Do not screenshot, record, or send them to anyone.",
    "backupTip3": "WinPay never stores your mnemonic or private key.",
    "backupSensitiveConfirm": "Make sure your surroundings are secure before continuing.",
    "sensitiveExportTodo": "Sensitive export flow migration in progress",
    "privateKeyUnavailable": "No private key export available for this wallet",
    "specialReminder": "Special reminder",
    "safetyReminder": "Safety Reminder",
    "privateCarefulExport": "After exporting the private key, store it offline with extreme care. Exposure may lead to asset loss.",
    "clickShowPrivateKeyQr": "Click to Show QR code of Private Key",
    "plaintextPrivateKey": "Plaintext Private Key",
    "copyPrivateKey": "Copy Private Key",
    "copyPrivateKeyAfter": "After copying the private key, be sure to store it properly, otherwise it may cause asset loss.",
    "copyMnemonicAfter1": "After copying the recovery phrase, ",
    "copyMnemonicAfter2": "do not open other apps",
    "copyMnemonicAfter3": " to prevent clipboard leakage.",
    "notPasteMnemonic1": "Do not paste your recovery phrase into ",
    "notPasteMnemonic2": "any internet-connected application",
    "notPasteMnemonic3": "Do not use ",
    "notPasteMnemonic4": "any cloud storage or chat tools for backup",
    "notShareMnemonic1": "Do not share your mnemonic with anyone. Please note that",
    "notShareMnemonic2": "We will never ask for your mnemonic",
    "winpayCard": "WinPay Card",
    "openCardTitle": "Open Card Now",
    "openCardDesc": "Connect account assets with global payments",
    "openCardProcess": "Open Card Flow",
    "openCardStep1": "KYC Verification",
    "openCardStep2": "Select Card",
    "openCardStep3": "Activate",
    "cardSecure": "Safe",
    "cardSecureDesc": "Risk controls",
    "cardGlobal": "Global",
    "cardGlobalDesc": "Multi-scenario payments",
    "cardAsset": "Balance",
    "cardAssetDesc": "Unified balance",
    "openCardNow": "Open Card Now",
    "cardKycTodo": "Card KYC flow migration in progress",
    "activatePhysicalCard": "Activate physical card",
    "activatePhysicalCardEntry": "Activate physical card",
    "activatePhysicalDesc": "Enter card number and activation code after receiving the card",
    "cardNumber": "Card Number",
    "enterCardNumber": "Enter card number",
    "activeCode": "Activation Code",
    "enterActiveCode": "Enter activation code",
    "emailCode": "Email verification code",
    "enterEmailCode": "Enter email code",
    "sendCode": "Send Code",
    "activateNow": "Activate Now",
    "activateTip1": "Activate only after receiving the physical card.",
    "activateTip2": "Check card number, email code, and activation code before submitting.",
    "cardApiTodo": "Card API migration in progress",
    "completeCardActiveForm": "Complete activation information",
    "activateSuccess": "Activated",
    "submitSuccess": "Submitted successfully",
    "physicalTransferDesc": "Balance transfer between physical cards",
    "fromCard": "From Card",
    "selectCard": "Select",
    "toCard": "To Card",
    "enterTargetCard": "Enter target card number",
    "remark": "Remark",
    "optionalRemark": "Optional",
    "completePhysicalTransferForm": "Complete transfer information",
    "transferFrom": "From",
    "transferTo": "To",
    "fundingAccount": "Fund Account",
    "exchangeCoin": "Exchange Asset",
    "availableBalance": "Available Balance",
    "transferInAmount": "Transfer In Amount",
    "transferOutAmount": "Transfer Out Amount",
    "withdrawFeeLabel": "Withdrawal Fee",
    "failed": "Failed"
  },
  "invite": {
    "title": "Invite",
    "inviteNow": "Invite Now",
    "share": "Share",
    "claim": "Claim",
    "claimSuccess": "Claimed",
    "pendingClaim": "Claimable",
    "claimableAmount": "Claimable (USDT)",
    "claimed": "Claimed",
    "expired": "Expired",
    "copyUrl": "Copy link",
    "saveQrCode": "Save QR",
    "saveImage": "Save",
    "posterTitle": "One Card · Pay Globally",
    "posterTagline": "Global Payments · One Wallet",
    "pointsRules": "Invite rules",
    "referralStepsTitle": "Referral Steps",
    "pointsRulesComingSoon": "Coming soon",
    "heroTitle": "Refer & Earn",
    "hero1": "Refer & Earn Up to",
    "hero2": "60%",
    "hero3": "Rewards",
    "heroDesc": "View Rules & Start Earning",
    "partner": "Partner",
    "partnerPromotion": "Become a WinPay Partner. Earn More.",
    "partnerJoinNow": "Join Now",
    "coursePromotionTitle": "Referral Steps",
    "purchaseCardToInvite": "Get a card to unlock invitations",
    "purchaseCardToInviteDesc": "You have completed identity verification. Purchase a virtual or physical card to receive your exclusive invitation code and link, and start earning invitation rewards.",
    "unlockInviteTitle": "How to unlock your invite code and link:",
    "unlockInviteDesc": "Purchase any card to get your exclusive invite code and link.",
    "purchaseCardToInviteLater": "Maybe later",
    "purchaseCardToInviteNow": "Buy a card",
    "kycPurchaseCardDesc": "Complete identity verification, then purchase a virtual or physical card to unlock this feature.",
    "coursePromotionDesc": "View Steps and Earn Rewards",
    "cardOpeningCommission": "Commission for Inviting Friends to Open a Card",
    "cardOpeningCommissionShort": "Card-opening commission",
    "spendingCommission": "Spending commission",
    "commissionRefundDeduction": "Commission deduction due to refund",
    "reservedReward": "Reserved",
    "courseCommission": "Card-opening Tier 2 commission",
    "globalDirectorCourseCommission": "Sole Global Director card-opening Tier 2 commission",
    "globalDirectorCardOpeningCommission": "Sole Global Director card-opening commission",
    "teamBonusPoolCardOpeningCommission": "Team bonus pool card-opening commission",
    "teamBonusPoolCourseCommission": "Team bonus pool card-opening Tier 2 commission",
    "globalDirectorTeamCardOpeningCommission": "Sole Global Director team card-opening commission",
    "globalDirectorTeamCourseCommission": "Sole Global Director team card-opening Tier 2 commission",
    "inviteFriendCardOpeningCommission": "Commission for Inviting a Friend to Open a Card",
    "invitationCommission": "Refer",
    "purchaseCommission": "Get Card",
    "consumptionCommission": "L2 Comm.",
    "friendCourseCommission": "Friends' card-opening Tier 2 commission",
    "inviteFriendCourseCommission": "Commission for a Friend's Card-opening Tier 2",
    "monthlyCommission": "Monthly",
    "monthlyBonusPoolCommission": "Team Rewards",
    "globalDirectorExclusiveCommission": "Exclusive Commission for the Sole Global Director",
    "globalDirectorCardOpeningReward": "Sole Global Director Card Opening Reward",
    "monthlyCommissionTitle": "Team",
    "monthlyCommissionIntro": "Accumulate more than 5 valid direct card openings to qualify for the V3 team reward.",
    "monthlyCommissionTip1": "Card-opening commission settlement",
    "monthlyCommissionTip1Desc": "After reaching V3, invite friends to complete valid card openings to earn rewards.",
    "monthlyCommissionTip2": "Tiered rewards",
    "monthlyCommissionTip2Desc": "Settled twice a month; your T tier is determined by the number of valid direct referrals.",
    "monthlyCommissionTip3": "Team reward details",
    "monthlyCommissionTip3Desc": "When a friend completes a valid course purchase, it contributes to the semi-monthly team reward pool.",
    "monthlyCommissionTip4": "Team reward settlement",
    "monthlyCommissionTip4Desc": "Settled twice a month; the final amount is subject to the system settlement result.",
    "consumptionRefund": "Invite Friends Card-opening Commission",
    "friendConsumptionRewardRefund": "Friend spend refund",
    "rewardRecordCardOpeningTitle": "[Friend-{friendName}] Card-opening commission",
    "rewardRecordConsumptionTitle": "[{friendName}] spend reward",
    "rewardRecordRefundTitle": "[{friendName}] spend refund",
    "rewardRecordCourseCommissionTitle": "[Friend-{friendName}] Card-opening Tier 2 commission",
    "rewardRecordFriendCourseCommissionTitle": "Invite [{friendName}] friends' card-opening Tier 2 commission",
    "rewardRecordMonthlyCommissionTitle": "[{friendName}] monthly commission",
    "rewardRecordMonthlyBonusPoolTitle": "[{friendName}] monthly bonus pool commission",
    "rewardRecordRegistrationTitle": "Invite [{friendName}]",
    "invitationTotal": "Referrals",
    "notUnlocked": "Not unlocked yet",
    "purchaseCommissionTitle": "Card Rewards",
    "purchaseCommissionIntro": "Earn card rewards when friends activate a WinPay Card.",
    "purchaseCommissionTip1": "The higher your level, the higher your commission rate. ",
    "purchaseCommissionTip1Desc": "Invite more friends to open cards. Meet the requirements to join the team bonus pool.",
    "purchaseCommissionTip2": "Virtual and physical cards earn the same rewards after activation.",
    "purchaseCommissionTip2Desc": "",
    "purchaseCommissionTip3": "Card reward settles after opening",
    "purchaseCommissionTip3Desc": "Paid within 3 business days.",
    "purchaseCommissionTip3DescPrefix": "Paid within ",
    "purchaseCommissionTip3Time": "Card activated successfully; commission is settled instantly.",
    "purchaseCommissionTip3DescSuffix": ". Rewards are automatically credited to your total assets account.",
    "purchaseCommissionConfirm": "Got it",
    "consumptionCommissionTitle": "Level 2 Referral Commission",
    "consumptionCommissionIntro": "When someone you invite invites a new user, you will receive an additional 25% platform reward on the commission earned by that new user.",
    "consumptionCommissionTip1": "Spend reward rules",
    "consumptionCommissionTip1Desc": "For example: A invites B, and B invites C. If C generates a 25 USDT commission for B, A will receive an additional 6.25 USDT platform reward.",
    "consumptionCommissionTip2": "Spend refund rules",
    "consumptionCommissionTip2Desc": "Refund within 30 days: no reward.",
    "consumptionCommissionTip2Partial": "Partial refund",
    "consumptionCommissionTip2PartialDesc": "Recalculated by valid spend.",
    "consumptionCommissionTip3": "Refund after payout",
    "consumptionCommissionTip3Desc": "Refunded or cancelled orders may have paid rewards recovered.",
    "points": "My points",
    "inviteMethod": "Invite method",
    "invitationCode": "My invite code",
    "shareQr": "Invite QR",
    "invitationLink": "My invite link",
    "myExclusiveInvite": "My Referral",
    "invitationCodeShort": "Code",
    "invitationLinkShort": "Link",
    "invitationRelationTip": "Use the code or link to connect and earn rewards.",
    "recommender": "Referrer",
    "enterRecommenderCode": "Enter code",
    "scanRecommenderCode": "Scan code",
    "viewFullRecords": "View All",
    "personUnit": "people",
    "invitedFriendsTotal": "Total Valid Referrals",
    "pendingCommission": "Pending Rewards",
    "totalCommission": "Total Rewards",
    "parentCode": "Inviter",
    "enterParentCode": "Enter invitation code",
    "bind": "Bind",
    "bound": "Bound",
    "rewardDetails": "Reward details",
    "commissionDetails": "Commission Details",
    "recommendedUsers": "Referred users",
    "tradingFriends": "Spending friends",
    "registeredFriends": "Registered friends",
    "noRecommendedUsers": "No referred users",
    "totalCommissionUsdt": "Total Rewards（USDT）",
    "withdrawable": "Claimable",
    "pendingSettlement": "Pending",
    "pendingSettlementTitle": "Pending (USDT)",
    "pendingSettlementDescription": "Settle before claiming; refunds reverse rewards.",
    "pendingSettlementQuestion": "When will it settle?",
    "pendingSettlementMonthlyCommission": "Team commission: settled twice a month",
    "pendingSettlementCardActivation": "Card activation: commission is settled and credited instantly after successful activation",
    "pendingSettlementTransaction": "Card-opening Tier 2 commission: settled and credited instantly after purchase verification",
    "settled": "Settled",
    "myRewards": "My Rewards",
    "date": "Date",
    "selectDate": "Select Date",
    "rewardSuccess": "Success",
    "rewardReady": "Claimable",
    "rewardVoided": "Voided",
    "rewardPartialRefund": "Partly refunded",
    "rewardRefunded": "Refunded",
    "rewardDeducted": "Deducted",
    "rewardDeductionFailed": "Deduction failed",
    "rewardCredited": "Credited",
    "rewardCardType": "Card type",
    "rewardType": "Reward type",
    "friendNickname": "Friend name",
    "invitationRelation": "Referral relationship",
    "indirectFriend": "Indirect referral",
    "rewardAmount": "Reward",
    "percentageWeight": "Percentage weight",
    "deductionAmount": "Deducted",
    "commissionAllocationRatio": "Allocation ratio",
    "commissionAllocationRatioUnavailable": "Not available yet",
    "commissionSettlementCycle": "Settlement cycle",
    "teamCommissionSettlementCycle": "Settled twice a month",
    "commissionSettlementMethod": "Settlement method",
    "commissionInstantSettlement": "Credited instantly",
    "commissionTriggerTime": "Trigger time",
    "commissionSettlementTime": "Settlement time",
    "friendConsumptionRefundTime": "Friend refund time",
    "commissionDeductionTime": "Deduction time",
    "commissionStatus": "Status",
    "rewardDetailsAmountPrefix": "Reward details ",
    "balanceAfter": "Balance ",
    "noRewardRecords": "No records",
    "inviteSteps": "Invite steps",
    "step1": "Share the link or code",
    "step2": "Invited friends complete identity verification and apply for a card through the link or invitation code",
    "step3": "You will receive commission rewards when friends activate their card"
  },
  "task": {
    "title": "Earn Points by Check-in",
    "dailyCheckIn": "Daily Check-in",
    "howToGetPoints": "How to Get Points",
    "myPoints": "My Points",
    "dailyTasks": "Daily Tasks",
    "checkInTotal": "Total Check-ins",
    "days": " consecutive days",
    "checkInRules": "Check-in Rules",
    "checkInRuleOne": "1. Daily check-in shows 7 days; rewards go 5/10/15 points, cycling every 3 days.",
    "checkInRuleTwo": "2. If you miss a day, rewards restart from 5 points.",
    "moreCheckInsMorePoints": "The more you check in, the more points you earn~",
    "checkedInDaysPrefix": "Checked in for ",
    "checkedInDaysSuffix": " consecutive days",
    "checkedInTodayTomorrow": "Checked in today. Come back tomorrow~",
    "routineTasks": "Routine Tasks",
    "dailyPointsLimit": "Daily Points Limit: 1000",
    "basicGrowth": "Basic Growth",
    "completeSignature": "Complete Signature",
    "signatureDone": "Signature Completed",
    "pointsPlusOne": "Points +1",
    "goFollow": "Go Follow",
    "postMoments": "Post Moments",
    "perPost": "Per Post",
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "saturday": "Saturday",
    "sunday": "Sunday"
  },
  "card": {
    "title": "Cards",
    "myCards": "My card",
    "openCard": "Apply Card",
    "benefits": "Benefits",
    "bill": "Bill",
    "empty": "No Related Cards Available",
    "virtualCard": "Virtual Card",
    "physicalCard": "Physical Card",
    "courseCard": "Course Card",
    "courseGiftNoticePhysical": "Successfully purchase a physical card to receive an exclusive in-person course. A course link will be sent to your registered email. Click it to view details and participation instructions.",
    "courseGiftNoticeVirtual": "Successfully purchase a virtual card to receive an exclusive in-person course. A course link will be sent to your registered email. Click it to view details and participation instructions.",
    "applyCard": "Apply Card",
    "applyNow": "Apply Now",
    "virtualDesc": "Contactless payment anytime, anywhere, both online and offline!",
    "physicalDesc": "No annual fee. ATM worldwide!",
    "applyCardTypeOne": "Apply for a virtual card",
    "applyCardTypeTwo": "Apply for a physical card",
    "applyCardTip1": "Apply online for online and offline payments",
    "applyCardTip2": "Physical cards support home delivery, ATM withdrawals and POS purchases",
    "applyCardTip3": "Apply online and activate after receiving the physical card",
    "applyCardTip4": "View and manage virtual and physical cards",
    "kycDialogTitle": "Verify identity",
    "kycDialogDesc": "Please complete identity verification to unlock this feature",
    "kycDialogAction": "KYC now",
    "useInstruction": "Card Binding Guide",
    "virtualCardUseInstruction": "Virtual card instructions",
    "entityCardUseInstruction": "Physical card instructions",
    "useInstructionText1": "Virtual card supports Alipay, Meituan, and online payments.",
    "useInstructionText2": "Physical card supports Alipay, Meituan, POS, online/offline spending, and ATM withdrawals.",
    "useInstructionText3": "Do not share your card number, expiry date, or CVV.",
    "useInstructionText4": "After unbinding, the card cannot be restored. This action cannot be undone.",
    "useInstructionText5": "After unbinding, the card fee is non-refundable, but the remaining balance returns to your wallet.",
    "useInstructionText6": "If you need help, go to Me - Contact Us - Online Support.",
    "useInstructionText7": "How to bind",
    "useInstructionText8": "Alipay",
    "useInstructionText9": "Follow the steps below to bind your card quickly and easily",
    "useInstructionText10": "Open Alipay",
    "useInstructionText11": "Open the Alipay app and tap Me",
    "useInstructionText12": "Go to Bank Cards",
    "useInstructionText13": "Choose the add card entry under Bank Cards or Payment Settings",
    "useInstructionText14": "Add a bank card",
    "useInstructionText15": "Tap Add Bank Card and enter your WinPay card number",
    "useInstructionText16": "Fill in card information",
    "useInstructionText17": "Enter the expiry date, CVV, code, and other required details.",
    "useInstructionText18": "Complete verification",
    "useInstructionText19": "After submission, complete SMS or security verification to finish linking.",
    "useInstructionText20": "Card instructions",
    "bindCardInfo1": "This Visa card is selected for Alipay scenarios and can be linked quickly by following the steps below.",
    "bindCardInfo2": "This Visa card is selected for Google Pay scenarios and can be linked quickly by following the steps below.",
    "bindCardInfo3": "This Visa card is selected for Apple Pay scenarios and can be linked quickly by following the steps below.",
    "bindCardInfo4": "Download and open Google Pay, then sign in",
    "bindCardInfo5": "On the Google Pay home screen, tap Add payment card",
    "bindCardInfo6": "Add a payment card",
    "bindCardInfo7": "Tap Add a credit or debit card",
    "bindCardInfo8": "Enter personal information",
    "bindCardInfo9": "Enter the card details and billing address, then tap Save and continue",
    "bindCardInfo10": "Open the card issuer terms page",
    "bindCardInfo11": "Scroll to the bottom and tap Continue",
    "bindCardInfo12": "Select a verification method, request a code, enter it in the verification field, and complete verification to finish linking",
    "bindCardInfo13": "Download and open Apple Pay, then sign in",
    "bindCardInfo14": "On the Apple Pay home screen, tap Add payment card",
    "bindCardInfo15": "Scan or manually enter the card details",
    "bindCardInfo16": "Enter the card number, name in English, expiry date, and security code",
    "bindCardInfo17": "Open the terms and conditions page",
    "bindCardInfo18": "Scroll to the bottom and tap Agree",
    "coreAdvantages": "Core advantages",
    "recommendedAudience": "Recommended audience",
    "cardScene": "Card Scene",
    "transferIn": "Transfer In",
    "transferOut": "Transfer Out",
    "atmPassword": "ATM PIN",
    "cardInfo": "Card Information",
    "mycard": "My card",
    "benefit": "Card Benefits",
    "recentTrade": "Bill",
    "viewAll": "View all",
    "noTrade": "No trade records",
    "noTradeEmpty": "No relevant data",
    "inUse": "In Use",
    "inactive": "Not activated",
    "frozen": "Frozen",
    "processing": "Processing",
    "success": "Success",
    "failed": "Failed",
    "cardSensitiveTodo": "Sensitive card info flow migration in progress",
    "cardWallet": "Cards",
    "cardBenefits": "Card Benefits",
    "noBenefit": "No benefit info",
    "withdrawMin": "Min Withdraw",
    "withdrawMax": "Max Withdraw",
    "rechargeMin": "Min Recharge",
    "rechargeMax": "Max Recharge",
    "monthlyLimit": "Monthly Limit",
    "billDetail": "Bill Details",
    "feeRate": "Payment Fee",
    "chargeFeeLabel": "Recharge Fee",
    "rechargeFeeLabel": "Initial Recharge",
    "withdrawFeeLabel": "Withdrawal Fee",
    "payFeeLabel": "Spending Fee",
    "selectCardTemplate": "Select Card Template",
    "selectScene": "Select Scene",
    "cardTemplate": "Card Template",
    "scene": "Scene",
    "selectTimeRange": "Select Time Range",
    "timeRangeTip": "Switch to the last 180 days to view reward details",
    "last30Days": "Last 30 Days",
    "last90Days": "Last 90 Days",
    "last180Days": "Last 180 Days",
    "currentScenario": "Current Scenario",
    "supportedScenes": "Supported Scenes",
    "supportedPlatforms": "Supported Platforms",
    "platformHint": "Subject to issuer support rules",
    "openCardAmount": "Card Opening Fee",
    "openCardAmountTip": "Includes issuance fee and initial recharge",
    "openFeeNoticePrefix": "Card opening fee",
    "openFeeNoticeSuffix": "will be credited to the card to keep it active",
    "firstRechargeTip": "Opening the card requires {amount} {symbol}, plus an initial recharge of {charge} {symbol}",
    "cardTitlePrefix": "Card ",
    "cardUsageLimit": "Spending Limit",
    "monthlyCardUsageLimit": "Limit/month",
    "prepaidCard": "Prepaid Card",
    "identityInfo": "Identity Information",
    "identityInfoTip": "Verified details will be used for card opening checks",
    "firstName": "Name",
    "lastName": "Last Name",
    "identityInfoEmpty": "Please complete verified identity details first",
    "agreementPrefix": "I have read and agree",
    "optionalInvitationCode": "Please enter the invitation code (optional)",
    "openCardNotice": "Opening Notes",
    "openCardNotice1": "The opening cost consists of the issuance fee and initial recharge amount, processed automatically after submission.",
    "openCardNotice2": "Supported platforms and fees vary by scenario and issuing channel. Final rules are subject to the provider.",
    "openCardNotice3": "If you plan to apply for a physical card later, make sure you already hold a bindable virtual card.",
    "termsAgree": "I have read and agree to the User Agreement and Privacy Policy",
    "agreeFirst": "Please agree to the terms first",
    "noCardTemplate": "No card templates are currently available",
    "balanceOverview": "Card benefits overview",
    "withdrawNotice": "Minimum physical card withdrawal {amount} {symbol}",
    "applyPhysicalCard": "Apply Physical Card",
    "physicalApplyDesc": "Verify identity, choose a template, fill shipping information, and wait for card production after payment.",
    "shippingFee": "Shipping",
    "shippingFree": "Free",
    "applicationFee": "Application Fee",
    "applicationFeeLabel": "Application fee: ",
    "recentTradeScene": "Selected Applicable Scenarios",
    "physicalSceneDesc": "Online and offline spending",
    "physicalOrderNotice": "Physical Card Notes",
    "physicalNotice1": "Open a bindable virtual card before applying for a physical card.",
    "physicalNotice2": "After successful payment, the card enters production and delivery.",
    "physicalNotice3": "Activate the card after receiving it before use.",
    "fillShippingInfo": "Enter shipping info",
    "requireVirtualCardFirst": "Open a bindable virtual card before applying for a physical card",
    "cardInfoTitle": "Card Information",
    "shippingInfoTitle": "Shipping info",
    "sameAsVirtualCard": "Same as virtual card",
    "receiverName": "Name",
    "enterReceiverName": "Enter",
    "completeAllInfo": "Please complete all info",
    "addressMinLength": "Address must be at least 5 chars",
    "completeShippingAddress": "Complete shipping information. Address must be at least 5 characters.",
    "saveLabel": "Save",
    "confirmOrder": "Confirm order info",
    "payPhysicalCardConfirm": "Confirm the physical card order and proceed to payment?",
    "payNow": "Pay Now",
    "orderPaid": "Payment successful",
    "paymentDetail": "Payment details",
    "paymentFee": "Fee paid",
    "paymentSuccess": "Payment successful",
    "paymentSuccessDesc": "Your card is being made. Delivery in 7-14 workdays.",
    "physicalCardMakingTip": "Physical cards take longer. Activate after delivery.",
    "paymentAmount": "Fee paid",
    "physicalArrivalTip1": "Physical card production usually takes longer. Please wait patiently.",
    "physicalArrivalTip2": "Activate the card first after delivery before using it.",
    "viewPendingCards": "View Pending Cards",
    "totalAssetsInsufficientBalance": "Insufficient total assets. Please top up before continuing.",
    "currentCardInsufficientBalance": "Insufficient card balance. Please top up first.",
    "topUpNow": "Top up",
    "pendingPhysicalCards": "Inactive card",
    "pendingActivate": "Not activated",
    "noPendingPhysicalCard": "No physical cards pending activation",
    "hasInactiveCards": "Inactive cards available",
    "physicalInstruction": "Physical card guide",
    "pendingNotice1": "You have successfully applied for a physical card. It is now being produced or shipped.",
    "pendingNotice2": "For account security, the physical card cannot be used before activation.",
    "pendingNotice3": "After receiving the card, tap below to activate.",
    "contactSupport": "Contact support",
    "invitationCode": "Invite code",
    "enterInvitationCode": "Please enter the invitation code (optional)",
    "openCardConfirm": "Submit card application?",
    "openCardSuccess": "Card application submitted",
    "kycTitle": "KYC Verification",
    "kycVerify": "KYC Verification",
    "kycRequirement": "Complete KYC verification before applying for a card.",
    "kycRequirement1": "Provide real and accurate information consistent with your document.",
    "kycRequirement2": "Verification is reviewed by the provider and may take some time.",
    "kycIntroTip": "Submit real identity details first. After approval, you can continue opening a virtual card.",
    "verifyNow": "Verify Now",
    "fillInfo": "Fill in info",
    "kycFormTip": "Fill in your usual contact details and billing address exactly as required.",
    "contactAndAddress": "Contact and Address",
    "countryCode": "Code",
    "selectCountryCode": "Select code",
    "phoneNumber": "Phone Number",
    "enterPhone": "Enter your phone number",
    "address": "Address",
    "selectCountry": "Select country",
    "selectCountryRegion": "Select Country/Region",
    "searchCountry": "Search country",
    "selectRegion": "Select state/province/region",
    "selectCity": "Select a city",
    "enterAddress": "Enter detailed address",
    "postalCode": "Postal Code",
    "enterPostalCode": "Enter postal code",
    "completeKycAddress": "Complete address info. Address must be at least 5 characters.",
    "kycSubmitted": "Information submitted",
    "kycReview": "Information Review",
    "kycRejected": "KYC verification rejected",
    "kycPending": "Information submitted, pending review",
    "kycApproved": "Info approved",
    "kycRejectedTip": "Please revise the information according to the rejection reason and resubmit.",
    "reviewTip": "Review finished, select a card to activate",
    "reviewDone": "Got It",
    "cardCanOpen": "You can choose a card now",
    "resubmit": "Resubmit",
    "failedReason": "Reason for Failure",
    "activatePending": "{count} physical cards pending activation",
    "oldCardTransferTip": "Legacy cards do not support transfer in / out after the WinPay card service upgrade.",
    "oldCardServiceUpgradeNotice": "WinPay has upgraded its virtual and physical card services. Legacy cards temporarily do not support transfer in or transfer out. Thank you for your understanding.",
    "cardProcessingWait": "Card is still processing. Please try again later.",
    "cardBalance": "Card Balance",
    "accountBalance": "Funding Balance",
    "availableBalanceLabel": "Available Balance:",
    "rechargeCurrencyTitle": "Recharge Currency",
    "rechargeAmountTitle": "Recharge Amount",
    "monthlyFee": "Monthly Fee",
    "supportedConsumptionScenes": "Supported Spending Scenarios",
    "keySupportedPlatforms": "Key Supported Platforms",
    "allSupportedPlatforms": "All supported platforms",
    "otherServices": "Other Services",
    "otherPlatforms": "Other Services",
    "cardUsageRules": "Card Usage Guidelines",
    "usageRule1": "High refund, cancellation, failure, or verification rates may cause card freezing risks.",
    "usageRule2": "Do not use on Steam, Blizzard, EA, Battle.net, OYSTER LABS, and similar platforms.",
    "usageRule3": "Prohibited to bind subscription platforms for automatic deductions",
    "cardSafetyTips": "Card Safety Tips",
    "cardSafetyTip1": "Do not disclose your card number, expiration date, or CVV information to others",
    "cardSafetyTip2": "Please use the prepaid card lawfully and only within compliant card scenarios",
    "unbindCard": "Unlink Card",
    "unBindCardText_1": "Before unbinding your card, please note the balance on the card:",
    "unBindCardText_2": "Any card balance will be refunded to your account within 1-7 business days after unbinding. Check history or contact support.",
    "unBindCardText_3": "The following impacts will occur after unbinding",
    "unBindCardText_4": "This card will no longer be available for payments or related transactions",
    "unBindCardText_5": "Automatic payment services linked to this card may be affected",
    "unBindCardText_6": "After unbinding, this card cannot be bound again",
    "unBindCardText_7": "Unbinding in progress",
    "unBindCardText_8": "Unbinding card...",
    "unBindCardText_9": "Please wait, it is expected to take two minutes",
    "unBindCardText_10": "To protect your funds, unbinding cannot be reversed",
    "unBindCardText_11": "Unbound successfully",
    "unBindCardText_12": "Card unbound successfully",
    "unBindCardText_13": "Your card has been successfully unbound and will no longer appear in the card list",
    "unBindCardText_14": "Unbinding failed",
    "unBindCardText_15": "Card unbinding failed",
    "unBindCardText_16": "Failed to unbind this card. Please try again later or contact support.",
    "unBindCardText_17": "Unbound cards",
    "unBindCardText_18": "Unbound",
    "unBindCardText_19": "Unbound card details",
    "unBindCardText_20": "Remaining amount when unbinding the card:",
    "unBindCardText_21": "Was the refund of the remaining amount successful:",
    "unBindCardText_22": "Card unbinding time:",
    "unbindCardStatus": "Card status",
    "unbindRefundYes": "Yes",
    "unbindRefundPending": "Processing",
    "minAmount": "Minimum Amount",
    "exchangeRate": "Current Price",
    "chargeArrivalTitle": "Recharge Arrived",
    "expectedCardArrival": "Expected Arrival",
    "expectedAccountArrival": "Withdrawal Arrival",
    "submitTransfer": "Confirm",
    "transferSuccess": "Transfer submitted",
    "transferSuccessTitle": "Tips",
    "transferInSuccessDesc": "Congratulations, you have successfully recharged",
    "transferOutSuccessDesc": "Congratulations, you have successfully withdrawn",
    "enterChargeAmount": "Enter the recharge amount",
    "enterTransferInAmount": "Enter transfer in amount",
    "enterTransferOutAmount": "Enter transfer out amount",
    "enterValidAmount": "Enter a valid amount",
    "tradeDetail": "Details",
    "tradeProcessingTip": "This transaction is still processing. Check back later for the final result.",
    "cardNumber": "Card Number",
    "tradeType": "Transaction Type",
    "tradeDescription": "Remark",
    "merchant": "Merchant",
    "amount": "Amount",
    "tradeAmount": "Transaction Amount",
    "orderNumber": "Order Number:",
    "orderId": "Order ID",
    "tradeTime": "Time",
    "noTradeDetail": "No trade detail available",
    "cvvTip": "The CVV is the 3 or 4 digit code on the back of the card used to verify your identity.",
    "sensitiveInfoLocked": "Wallet password verification is required before viewing the card number, expiry date, and CVV.",
    "sensitiveInfoLockedDesc": "For account safety, sensitive card information stays hidden until verification succeeds.",
    "unlockNow": "Verify and Unlock",
    "myCard": "My card",
    "basicInfo": "Card info",
    "cardType": "Card type",
    "cardholder": "Cardholder",
    "phoneNumberLabel": "Phone Number",
    "validThru": "Valid Thru (MM/YY)",
    "validThroughLabel": "Valid thru",
    "cvvCode": "CVV",
    "openSecurePage": "Open secure page in new window",
    "openVerificationPage": "Open verification page",
    "checkVerificationStatus": "Check verification status",
    "verificationPageUnavailable": "Verification page is unavailable for now. Please check the status later.",
    "diditSdkTitle": "Didit Face Verification",
    "sdkIdle": "Not started",
    "sdkLoading": "Loading verification",
    "sdkReady": "Verification in progress",
    "sdkUnavailable": "Failed to load Didit SDK. Open it externally instead.",
    "sdkCancelled": "KYC verification was cancelled",
    "sdkDeclined": "KYC verification was declined",
    "restartVerification": "Restart verification",
    "sdkCurrentStep": "Current Step",
    "sdkLastEvent": "Last Event",
    "sdkStepDocumentSelection": "Select document type",
    "sdkStepDocumentFront": "Capture document front",
    "sdkStepDocumentBack": "Capture document back",
    "sdkStepFace": "Face verification",
    "sdkStepEmail": "Email verification",
    "cameraPermissionTitle": "Enable Camera Permission",
    "cameraPermissionTip": "Document capture and face verification require browser camera access. Please grant camera permission first.",
    "cameraPermissionDenied": "Camera permission is not available right now. Please allow camera access in your browser settings before continuing.",
    "cameraPermissionGranted": "Camera permission is ready. You can continue with document capture and face verification.",
    "cameraPermissionGrantedToast": "Camera permission enabled",
    "cameraPermissionOpen": "Enable",
    "cameraPermissionReady": "Enabled",
    "cameraPermissionDialog": "Browser camera permission is currently unavailable. Please allow camera access from the browser address bar or system settings, then continue with KYC verification.",
    "sdkStepPhone": "Phone verification",
    "sdkStepPoa": "Proof of address",
    "sdkStepQuestionnaire": "Questionnaire",
    "sdkEventReady": "Verification page ready",
    "sdkEventStarted": "Verification started",
    "sdkEventStepStarted": "Step started",
    "sdkEventStepCompleted": "Step completed",
    "sdkEventStepChanged": "Step changed",
    "sdkEventMediaStarted": "Capture started",
    "sdkEventMediaCaptured": "Capture completed",
    "sdkEventDocumentSelected": "Document selected",
    "sdkEventSubmitted": "Verification submitted",
    "sdkEventCodeSent": "Code sent",
    "sdkEventCodeVerified": "Code verified",
    "sdkEventStatusUpdated": "Status updated",
    "sdkEventCompleted": "Verification completed",
    "sdkEventCancelled": "Verification cancelled",
    "sdkEventError": "Verification error",
    "sdkEventCloseRequest": "Close requested",
    "kycTokenEmpty": "KYC token is empty. Please try again later.",
    "viewAtmPassword": "View ATM PIN",
    "enterAtmPassword": "Enter 6-digit ATM PIN",
    "confirmAtmPassword": "Confirm ATM PIN",
    "atmPasswordTip": "*Set once only. You can view it later.",
    "sixDigitPin": "Enter a 6-digit numeric PIN",
    "setPinSuccess": "Password set successfully",
    "GoOpenCard": "Open Card"
  },
  "mine": {
    "title": "My",
    "mineCode": "My QR code",
    "scanAddFriend": "Scan to add as WinPay Wallet friend",
    "wallet": "Wallet Management",
    "cardCodeRedemption": "Redeem Card Code",
    "enterCardCode": "Enter Card Code",
    "security": "Security Settings",
    "language": "Switch Language",
    "selectLanguage": "Language",
    "contactUs": "Contact",
    "about": "About Us",
    "kyc": "KYC Verification",
    "userId": "User ID",
    "login": "Login/Register",
    "logout": "Sign Out",
    "logoutConfirm": "Log out of the current account?",
    "logoutConfirmTitle": "Sign Out?",
    "logoutConfirmAccount": "Sign out of the current account [{name}]?",
    "points": "Points",
    "currentLevel": "Level",
    "totalPoints": "Total Points",
    "nextLevelPoints": "{points} points to the next level",
    "levelSurpassed": "Current level exceeded",
    "maxLevelReached": "Maximum level reached",
    "exclusiveLevel": "Exclusive Level",
    "dailyCheckInPoints": "Daily check-in earns points",
    "rewardDetails": "Rewards",
    "signIn": "Check In",
    "signedIn": "Checked In",
    "checkInSuccess": "Check-in successful, earned {reward} points",
    "gameZone": "Game Zone",
    "gameDesc": "Earn Points Easily",
    "shopZone": "E-commerce Zone",
    "shopDesc": "Place Orders to Earn Points",
    "enterZone": "Enter",
    "inviteFriends": "Invite",
    "inviteDesc": "Invite friends to WinPay",
    "invitedUsers": "Invited registered wallets",
    "recommender": "Inviter",
    "bindSuccess": "Bound successfully",
    "takePhoto": "Take Photo",
    "chooseFromAlbum": "Choose from Library",
    "avatarUpdated": "Avatar updated",
    "avatarUploadFailed": "Avatar upload failed. Please try again later.",
    "avatarImageOnly": "Choose an image file",
    "avatarImageTooLarge": "Image size must be under {size}MB",
    "changeWalletName": "Rename Wallet",
    "enterWalletName": "Enter wallet name",
    "nameTooLong": "Name cannot exceed 16 characters",
    "nameUpdated": "Name updated",
    "securityTodo": "Security settings migration in progress",
    "kycTodo": "Verify Now",
    "kycPending": "Pending",
    "kycVerified": "Verified",
    "kycFailed": "Failed",
    "kycTodoDesc": "Complete KYC verification before continuing with virtual or physical card features.",
    "kycPendingDesc": "Your verification materials have been submitted and are under review.",
    "kycVerifiedDesc": "KYC verification is complete and card-related verification is available for this account.",
    "kycFailedDesc": "Verification was not approved. Please review the reason and submit again.",
    "viewKycResult": "View Result",
    "retryKyc": "Retry Verification",
    "aboutDesc": "One-stop Web3 social and payment wallet",
    "version": "Version",
    "contactDesc": "If you have any questions, such as wallet deletion or usage issues, please contact us through the following methods:",
    "supportEmail": "Customer Service Email",
    "onlineSupport": "Online Customer Service",
    "serviceMailbox": "Customer Service Mailbox",
    "serviceHours": "Support Hours",
    "weekdayHours": "Working Days: 09:00 AM - 06:00 PM",
    "supportReplyTip": "We will reply during service hours.",
    "supportThanks": "Thank you for your support and understanding."
  },
  "article": {
    "square": "Forum",
    "followTab": "Following",
    "likeTab": "Like",
    "nowTab": "Now",
    "create": "Post",
    "myArticle": "My Articles",
    "detail": "Article Detail",
    "addToken": "Add Token",
    "addNft": "Add NFT",
    "reportTitle": "Report",
    "reportSuccess": "Thanks for your feedback.",
    "reportFailed": "Submit failed. Try again later.",
    "reasonAttack": "Offensive and provocative",
    "reasonPorn": "Adult Content",
    "reasonDiscomfort": "Vulgar",
    "reasonSpam": "Spam ads",
    "follow": "Follow",
    "followed": "Followed",
    "followSuccess": "Followed",
    "unfollowSuccess": "Unfollowed",
    "likeSuccess": "Liked",
    "unlikeSuccess": "Unliked",
    "now": "Just Now",
    "minutesAgo": "Mins Ago",
    "hoursAgo": "Hours Ago",
    "daysAgo": "Days Ago",
    "views": "Views",
    "forwarded": "Relay",
    "empty": "No content",
    "searchPlaceholder": "Search",
    "unsupportedNetwork": "The current network does not support home content.",
    "switchNetwork": "Switch Network",
    "observerWalletWarn": "Watch-only wallets cannot access home content.",
    "switchWallet": "Switch Wallet",
    "openDetailTodo": "Article detail is pending migration",
    "createTodo": "Article publishing is pending migration",
    "addTokenTodo": "Add token is pending migration",
    "addNftTodo": "Add NFT is pending migration",
    "sampleName": "WinPay User",
    "sampleTopic": "Flutter article module migration preview",
    "sampleContent": "This page carries the migrated H5 styles, state, and sheet interaction for article modules."
  }
};
